// Unpublished Work © 2021-2023 Deere & Company

import {processEnvSvc} from './process-env-svc';

const toggles = processEnvSvc('FEATURE_TOGGLES');

export const isFeatureToggled = (feature) => Boolean(toggles[feature]);
